<template>

    <v-modal title="Edit Property">
        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Type">
                <v-select :model="params.type" @input="params.type = $event">
                    <option value="string">String</option>
                    <option value="number">Number</option>
                    <option value="boolean">Boolean</option>
                    <option value="date">Date</option>
                </v-select>
            </v-form-group>
            <v-form-group dir="ver" label="Format" v-if="params.type === 'string'">
                <v-select :model="params.format" @input="params.format = $event">
                    <option value="">Text</option>
                    <option value="email">Email</option>
                    <option value="url">URL</option>
                </v-select>
            </v-form-group>
            <v-form-group dir="ver" label="Format" v-if="params.type === 'number'">
                <v-select :model="params.format" @input="params.format = $event">
                    <option value="">Numeric</option>
                    <option value="currency">Currency</option>
                </v-select>
            </v-form-group>
            <v-form-group dir="ver" label="Format" v-if="params.type === 'boolean'">
                <v-select :model="params.format" @input="params.format = $event">
                    <option value="">Yes / No</option>
                    <option value="true-false">True / False</option>
                    <option value="on-off">On / Off</option>
                </v-select>
            </v-form-group>
            <v-form-group dir="ver" label="Format" v-if="params.type === 'date'">
                <v-select :model="params.format" @input="params.format = $event">
                    <option value="">Date Only</option>
                    <option value="date-time">Date + Time</option>
                    <option value="relative">Relative Time</option>
                </v-select>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white-danger" @click.native="$store.commit('showModal', 'property-delete')">Delete</v-button>
            <v-button size="sm" :loading="loading" @click.native="updateEventProperty">Save Property</v-button>
        </template>
    </v-modal>

</template>

<script>

import EventApi from '@api/EventApi'

export default {

    props: {
        event: {
            type: Object,
            required: true,
        },
        property: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                type: this.property.type,
                format: this.property.format,
            },
        }
    },

    methods: {

        updateEventProperty() {
            this.loading = true;
            EventApi.updateEventProperty(this.event.id, this.property.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false
                    this.error = error.response.data.message
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
